export const THREE_BY_ONE_HSCROLL_DEFAULT_BREAKPOINT_MAX = 550;
